import { useState, type FormEvent } from "react";
import { Navigate, useNavigate } from "react-router-dom";

import { useAuth } from "@/auth/AuthContext";

export function LoginPage() {
  const auth = useAuth();
  const nav = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  // Se già autenticato (es. utente apre /login direttamente), redirect alla
  // dashboard. Evita ambiguità di stato e logout accidentali.
  if (auth.token && auth.role) {
    return <Navigate to="/" replace />;
  }

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    setLoading(true);
    setErr(null);
    try {
      await auth.login(email, password);
      nav("/", { replace: true });
    } catch (e) {
      setErr(e instanceof Error ? e.message : "Accesso fallito");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-bg-0 px-4">
      <div className="card w-full max-w-[400px]">
        <div className="flex items-center gap-3 mb-5">
          <div className="bo-badge h-9 w-9 rounded-md" />
          <div>
            <div className="text-[16px] font-semibold">Quantica</div>
            <div className="text-[11px] uppercase tracking-wider text-muted">
              Backoffice
            </div>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="flex flex-col gap-3">
          <label className="flex flex-col gap-1">
            <span className="text-[11.5px] text-muted">Email</span>
            <input
              className="input"
              type="email"
              autoComplete="username"
              placeholder="email@quantica.local"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              disabled={loading}
            />
          </label>

          <label className="flex flex-col gap-1">
            <span className="text-[11.5px] text-muted">Password</span>
            <input
              className="input"
              type="password"
              autoComplete="current-password"
              placeholder="••••••••"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              disabled={loading}
            />
          </label>

          {err && (
            <div className="text-[12px] text-no border border-no/30 bg-no/10 rounded-md px-3 py-2">
              {err}
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            className="btn-primary mt-1"
          >
            {loading ? "Accesso in corso…" : "Accedi"}
          </button>
        </form>

        <div className="mt-5 pt-4 border-t border-line text-[11px] text-muted">
          Solo account con ruolo <span className="text-text-2">operation</span>{" "}
          o <span className="text-text-2">admin</span> possono accedere.
        </div>
      </div>
    </div>
  );
}
